
import { ProgramModule_mkProgram, ProgramModule_run } from "./fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Program_withReactBatched } from "./fable_modules/Fable.Elmish.React.5.6.0/react.fs.js";
import { MainView, update, init } from "./View.js";
import { createElement } from "react";

ProgramModule_run(Program_withReactBatched("safer-app", ProgramModule_mkProgram(init, update, (state_1, dispatch) => createElement(MainView, {
    state: state_1,
    dispatch: dispatch,
}))));

